<template>
  <div v-if="result" class="site-search-course-program-card-container">
    <a :href="`/course-preview/${result['slug']}`" @click="save_search">

      <div class="site-search-course-program-card">

        <div class="site-search-course-program-card__logo-container">
          <img class="site-search-course-program-card__logo" :src="$filters.analyseImage(result['cover-image'],'herosearchxs','herosearchsm')" width="54" height="54" alt="" loading="lazy">
        </div>

        <div class="site-search-course-program-card__body">

          <h4 class="site-search-course-program-card__title">{{ result['title'] }}</h4>

          <div class="site-search-course-program-card__group">
            
            <!-- v-if="result['event-date']" -->
            <div class="site-search-course-program-card__body-group-date" >
              <div class="icon-wrapper">
                <img class="icon" :src="`/images/icons/icon-clock-outline.svg?${$config.version}`" alt="Clock" loading="lazy" />
              </div>
              <p>??th MMM - ??:??</p>
              {{ $filters.ukDateTime(result['event-date']) }}
              <!-- <p class="site-search-course-program-card__footer-title">{{ $filters.ukDateShort(result['date-start']) }}</p> -->
            </div>

            <template v-if="result['cost'] !== undefined">
              <div v-if="result['cost'] > 0" class="site-search-course-program-card__footer-price">
                <p class="text-blue-light">£{{ result['cost'] }}</p>
              </div>
              <div v-if="!result['cost'] || result['cost'] == 0" class="site-search-course-program-card__footer-price">
                <p class="text-green">Free</p>
              </div>
            </template>

          </div>
        </div>

        <svg-chevron-left></svg-chevron-left>

      </div>

    </a>
  </div>
</template>

<script>
import { isSameMonth } from 'date-fns';

export default {
  props: {
    result: {
      type: [Object],
      default: {}
    }
  },

  data() {
    return {

    }
  },

	mounted() {
		console.log('site search course', this.result);
	},

  methods: {
		save_search() {
			this.$emit('save:search');
		}
  },

  computed: {
    isClosingSoon() {
      return isSameMonth(new Date(), this.result['date-start']);
		},
    isOnline() {
      if (this.result['online']) {
				return 'Online';
			} else {
				console.log(this.result['location-text']);
				if (this.result['location-text']) {
					return this.result['location-text'];
				}
			}
			return 'In person';
    }
  }
}
</script>
